(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairImportScheduleUrlController', VirtualFairImportScheduleUrlController)

        VirtualFairImportScheduleUrlController.$inject = ['$uibModal', 'VirtualFairService', 'virtualFairs'];


    function VirtualFairImportScheduleUrlController($uibModal, VirtualFairService, virtualFairs) {
        var vm = this;

        vm.exhibitors            = '';
        vm.queryFlag             = false;
        vm.expos                 = '';
        vm.expoSelected          = '';
        // vm.selectExpo            = selectExpo;
        vm.getByFilter           = getByFilter;
        vm.openUploadModal       = openUploadModal;
        vm.virtualFairs          = virtualFairs;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems   = 0;
        vm.currentPage  = 0;
        vm.itemsPerPage = 0;
        vm.page         = 1;


        activate();


        function setPage(page) {
            vm.currentPage = page;
        };


        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        };


        function activate() {
            // vm.selectExpo();
        }

        function selectExpo() {
            vm.query = {};
            VirtualFairService.getSchoolVisits(vm.query).then(function(response){
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function openUploadModal() {
            $uibModal.open({
                templateUrl: 'templates/virtualfairs/import-schedule-url/upload/upload.modal.html',
                controller: 'VirtualFairImportScheduleUrlModalController',
                controllerAs:'vm',
                resolve:
                {
                    virtualFair: function() {
                        return vm.expoSelected;
                    }
                }
            });
        }

        function getByFilter() {
            vm.query = {};
            vm.query['search']          = vm.expoSelected.id;
            vm.query['searchFields']    = 'virtual_fair_id';
            vm.query['orderBy']         = 'name';
            vm.query['page']            = vm.page;
            VirtualFairService.getExhibitors(vm.query).then(function(response) {
                vm.exhibitors = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.queryFlag = true;
                vm.setPage(response.data.current_page);

            }).catch(function(err) {
            });
        }

    }

})();
